import React from 'react'

const Manual_admin_tipo_orden = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
          Admin - Tipo de Orden
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          La guía explica cómo crear y personalizar tipos de pedidos para mejorar la eficiencia operativa. Incluye funciones como propina automática, entrada de direcciones, selección de mesas y impresión de cheques previos, optimizando el flujo de trabajo y el servicio al cliente.
        </p>
        <iframe
          src="https://scribehow.com/embed/Admin__Tipo_de_Orden__aGPRh5RpQkSIxUc72Q_vsQ?as=scrollable"
          className="scribe-iframe-general-51"
          width="100%"
          height="3600"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_admin_tipo_orden